<div class="upload-container">
  <fieldset class="items-fieldset">
    <legend class="items-fieldset--legend">
      {{ 'attachments' | i18nextCap }}
    </legend>
    <div class="attachments">
      <div class="attachment">
        <div class="attachment-input">
          <div class="icon-container">
            <fa-icon [icon]="faCloudArrowUp" size="xl"></fa-icon>
          </div>
          <div>{{ 'clickOrDropToAttach' | i18nextCap }}</div>
          <input
            [disabled]="disabled"
            class="upload-attachment"
            type="file"
            multiple
            [accept]="acceptString"
            (change)="attach($event)"
          />
        </div>
      </div>

      @for (a of attachments; track a) {
      <div class="attachment">
        @if (isImg(a?.file?.fileName)) {
        <div class="img-container" (click)="openDialog(a)">
          <img [src]="a?.file?.signedUrl" width="140px" />
        </div>
        } @else {
        <div class="img-container-text" (click)="openDialog(a)">
          <div class="file-icon">
            <fa-icon [icon]="fileIcon" size="xl"></fa-icon>
          </div>
          <div class="file-name">{{ a.label || a.file?.fileName }}</div>
        </div>
        }
        <button
          [disabled]="disabled"
          type="button"
          mat-button
          color="warn"
          (click)="detach(a.id)"
          class="remove-icon"
        >
          <fa-icon [icon]="crossIcon" size="xl"></fa-icon>
        </button>
      </div>
      }
    </div>
  </fieldset>
</div>
